import { Box, Stack } from '@mui/material';
import React, { useMemo } from 'react';
import { useCreatePlanContext } from '../../../../../contexts/create-plan-context';
import { PLAN_CREATION_STEPS } from '../../../../../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import {
  VyStepFields,
  VyStepper,
} from '../../../../../components/new-design/data-display/VyStepper/VyStepper';
import { useFormContext } from 'react-hook-form';

export const CreatePlanPageStepper: React.FC = () => {
  const {
    planCreationStepper: { currentStep, goToStep },
  } = useCreatePlanContext();
  const {
    formState: { isValid },
  } = useFormContext();

  const createPlanPageSteps = useMemo(
    () => getCreatePlanPageSteps(currentStep, isValid),
    [currentStep, isValid],
  );

  return (
    <Stack
      sx={(theme) => ({
        backgroundColor: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        padding: '24px 0px 16px 0px',
      })}
    >
      <Box
        style={{
          margin: '0 auto',
        }}
      >
        <VyStepper
          steps={createPlanPageSteps}
          activeStep={currentStep}
          keyExtractor={(step) => step.label}
          onStepClick={(step) => goToStep(step.stepIndex)}
          renderStepLabel={({ label }) => label}
        />
      </Box>
    </Stack>
  );
};

function getCreatePlanPageSteps(activeStep: number, isFormValid: boolean): VyStepFields[] {
  return [
    {
      label: 'General terms',
      stepIndex: PLAN_CREATION_STEPS.settings,
      isDisabled: false,
      isCompleted: activeStep > PLAN_CREATION_STEPS.settings,
    },
    {
      label: 'Pricing & Products',
      stepIndex: PLAN_CREATION_STEPS.pricingAndProducts,
      isDisabled: !isFormValid,
      isCompleted: activeStep > PLAN_CREATION_STEPS.pricingAndProducts,
    },
  ];
}
